module.exports = __webpack_public_path__ + "static/media/bill-desk-laptop.839f402d.svg";